import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { HeadingText } from '@paypalcorp/pp-react';
import { getDonateLocaleAPIFormat } from '../utils/localeUtils.js';

const getRemainingTime = function (millis) {
  const remainingTimeOptions = { minute: '2-digit', second: '2-digit' };

  const remainingTime = new Date(0);
  remainingTime.setMilliseconds(millis);

  return remainingTime.toLocaleTimeString(
    getDonateLocaleAPIFormat(),
    remainingTimeOptions
  );
};

const CountdownTimer = (props) => {
  const { milliseconds = 1 * 60 * 1000 } = props;

  const [timeLeft, setTimeLeft] = useState(milliseconds);

  useEffect(() => {
    if (timeLeft > 0 && !props.pause) {
      const intervalId = setInterval(() => {
        setTimeLeft(timeLeft - 1000);
      }, 1000);
      return () => clearInterval(intervalId);
    } else if (timeLeft === 0) {
      props.onTimeout(true);
    }
  }, [timeLeft, props.pause]);

  return (
    <HeadingText className="countdown-timer-text" style={props.styles}>
      {getRemainingTime(timeLeft)}
    </HeadingText>
  );
};

CountdownTimer.propTypes = {
  milliseconds: PropTypes.number,
  pause: PropTypes.bool,
  styles: PropTypes.object,
  onTimeout: PropTypes.func,
};

export default CountdownTimer;
